<template>
  <div>
    <h3 class="h-title">服务要素信息</h3>
    <el-form class="e-form f-b" ref="cForm2" :model="cForm2" label-width="160px"  label-position="left" :rules="cRules">
      <el-form-item label="选择律所" prop="lawFirmObj">
        <el-select v-model="cForm2.lawFirmObj" @change="setLawFirm" value-key="nodeId" placeholder="请选择律所" style="width: 100%">
          <el-option
            v-for="dict in lawOptions"
            :key="dict.nodeId"
            :label="dict.nodeName"
            :value="dict"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择权威节点" prop="authorityNodeArr">
        <el-select v-model="cForm2.authorityNodeArr" 
        @remove-tag="changeNode" 
        @change="seteNode" multiple         
        filterable 
        @input.native="filterData"
        @clear="clearData"
        value-key="nodeName" placeholder="请选择权威节点" style="width: 100%">
          <el-option
            v-for="item in nodeOptions"
            :key="item.id"
            :label="item.nodeName"
            :disabled="item.isRequire == '0'"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="存储类型" prop="saveType">
        <el-select v-model="cForm2.saveType" placeholder="请选择存储类型" style="width: 100%">
          <el-option
            v-for="dict in typeOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据名称" prop="dataName">
        <el-input v-model="cForm2.dataName" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>




      <el-form-item label="生产方式" prop="produceMethod">
        <el-select v-model="cForm2.produceMethod" placeholder="请选择生产方式" style="width: 100%">
          <el-option label="人工收集和录入" value="人工收集和录入" />
          <el-option label="系统收集" value="系统收集" />
          <el-option label="网上或移动应用收集" value="网上或移动应用收集" />
          <el-option label="公开来源获得" value="公开来源获得" />
          <el-option label="数据共享" value="数据共享" />
          <el-option label="数据购买" value="数据购买" />
          <el-option label="数据融合" value="数据融合" />
          <el-option label="其他" value="其他" />
        </el-select>
        <el-input v-model="cForm2.produceMethodOther" v-if="cForm2.produceMethod == '其他' " placeholder="请输入其他" />
      </el-form-item>
      <el-form-item label="权属确认类型" prop="belongType">
        <el-select v-model="cForm2.belongType" placeholder="请选择权属确认类型" style="width: 100%">
          <el-option label="数据资源持有权" value="数据资源持有权" />
          <el-option label="数据加工使用权" value="数据加工使用权" />
          <el-option label="数据产品经营权" value="数据产品经营权" />
        </el-select>
      </el-form-item>
      <el-form-item label="更新频率" prop="updateFrequency">
        <el-select v-model="cForm2.updateFrequency" placeholder="请选择更新频率" style="width: 100%">
          <el-option label="每天" value="每天" />
          <el-option label="每周" value="每周" />
          <el-option label="每月" value="每月" />
          <el-option label="每季度" value="每季度" />
          <el-option label="每半年" value="每半年" />
          <el-option label="每年" value="每年" />
          <el-option label="其他" value="其他" />
        </el-select>
        <el-input v-model="cForm2.updateFrequencyOther" v-if="cForm2.updateFrequency == '其他' " placeholder="请输入其他" />
      </el-form-item>
      <el-form-item label="数据规模" prop="dataScale">
        <el-input v-model="cForm2.dataScale" placeholder="请输入数据规模，如“213,900,84条”" />
      </el-form-item>
      <el-form-item class="w-70" label="预估数据价值(万元)" prop="estimateDataValue" >
        <el-input-number v-model="cForm2.estimateDataValue" controls-position="right" @blur="conversion('estimateDataValue')" :precision="4" :step="0.1" :min="cForm2.consensusAmount||0" placeholder="请输入数字，小数点后4位" style="width: 100%"></el-input-number>
      </el-form-item> 
      <el-form-item label="应用场景" prop="applicationScene">
        <el-select v-model="cForm2.applicationScene" placeholder="请选择更新频率" style="width: 100%">
          <el-option label="金融服务" value="金融服务" />
          <el-option label="零售服务" value="零售服务" />
          <el-option label="医疗" value="医疗" />
          <el-option label="政府服务" value="政府服务" />
          <el-option label="交通运输" value="交通运输" />
          <el-option label="能源管理" value="能源管理" />
          <el-option label="教育" value="教育" />
          <el-option label="农业生产" value="农业生产" />
          <el-option label="市场营销" value="市场营销" />
          <el-option label="人力资源" value="人力资源" />
          <el-option label="客户服务" value="客户服务" /> 
          <el-option label="其他" value="其他" />
        </el-select>

         <el-input v-model="cForm2.applicationSceneOther" v-if="cForm2.applicationScene == '其他' " placeholder="请输入其他" />
      </el-form-item>
      <el-form-item label="是否完成合规评估" prop="completeConformanceAssess">
        <el-radio-group v-model="cForm2.completeConformanceAssess">
          <el-radio label="有"></el-radio>
          <el-radio label="无"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否完成质量评估" prop="completeQualityAssess">
        <el-radio-group v-model="cForm2.completeQualityAssess">
          <el-radio label="有"></el-radio>
          <el-radio label="无"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否完成价值评估" prop="completeValueAssess">
        <el-radio-group v-model="cForm2.completeValueAssess">
          <el-radio label="有"></el-radio>
          <el-radio label="无"></el-radio>
        </el-radio-group>
      </el-form-item> 
    </el-form>
    <div class="cenrer">			
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </div>
</template>

<script>
import { elFormErrorScrollIntoView } from '@/utils/util'
export default {
  name: "step2",
  props: ["active"],
  data() {
    return {
      headers: {},
      action: '',
      file: '',
      butLoading: false,
      cFileList: [],
      cForm2: {},
      // 表单校验
      cRules: {
        lawFirmObj: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        authorityNodeArr: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        saveType: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        updateFrequency: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        applicationScene: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        completeConformanceAssess: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        completeQualityAssess: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        completeValueAssess: [
          { required: true, message: "请选择", trigger: "change" }
        ],

        belongType: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        produceMethod: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        dataName: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        dataScale: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractNo: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractPeriod: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        estimateDataValue: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        consensusAmount: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractSignName1: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractSignName2: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
      },
      lawOptions: [],
      nodeOptions: [],
      nodeTotal: 0,
      typeOptions: [],
      lawFirmOptions: [],
      mainContractSignNum: 0,
      subContractSignNum: 0,
      mainContractSignList: [],
      subContractSignList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 1000,
        businessType:'7', 
        status: '0'
      },
    }
  },
  watch: {
    active(newVal) {
        if(newVal == 2) {
          window.scrollTo(0,0);
          this.cForm2 = JSON.parse(sessionStorage.setpForm);
          this.getLawFirm()
          this.getNodeList()
          if(this.cForm2.mainContractPeriodStart){
            this.$set(this.cForm2, 'mainContractPeriod', [this.cForm2.mainContractPeriodStart, this.cForm2.mainContractPeriodEnd])       
          }
          if(this.cForm2.subContractPeriodStart){
            this.$set(this.cForm2, 'subContractPeriod', [this.cForm2.subContractPeriodStart, this.cForm2.subContractPeriodEnd])       
          }

          // 金额
          if(this.cForm2.estimateDataValue == null){
            delete this.cForm2.estimateDataValue
          }
          if(this.cForm2.consensusAmount == null){
            delete this.cForm2.consensusAmount
          }
          if(this.cForm2.subContractAmount == null){
            delete this.cForm2.subContractAmount
          }

          // 主体个数
          for(let j=10; j>2; j--){
            if(this.cForm2['mainContractSignName'+(j)]){
              this.mainContractSignNum = j-2;
              return
            }
          }
          // 从合同主体个数
          for(let j=10; j>2; j--){
            if(this.cForm2['subContractSignName'+(j)]){
              this.subContractSignNum = j-2;
              return
            }
          }
        } 
      }
    },
  methods: { 
    // 查询权威节点
    filterData(e){
      this.queryParams.pageNum = 1
      this.queryParams.nodeName = e.target.value;
      this.selectNode();
    },
    // 清空权威节点
    clearData() {
      this.queryParams.nodeName = ""
      this.queryParams.pageNum = 1
      this.selectNode();
    },
    selectNode(){
      this.$api.api.nodeList({...this.queryParams, nodeType: '1'}).then(response => {
        if(response.code == 200){
          this.nodeOptions = response.rows
        }else {
          this.$message.error(response.msg);
        } 
      })
    },
    conversion(name) {
      this.cForm2[name+'Rmb'] = this.smalltoBIG(this.cForm2[name]*10000);
    },
    /** 数字金额大写转换(可以处理整数,小数,负数) */    
    smalltoBIG(n){    
      let fraction = ['角', '分'];    
      let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];    
      let unit = [ ['元', '万', '亿'], ['', '拾', '佰', '仟']  ];    
      let head = n < 0? '欠': '';    
      n = Math.abs(n);    
    
      let s = '';    
    
      for (let i = 0; i < fraction.length; i++)     
      {    
          s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');    
      }    
      s = s || '整';    
      n = Math.floor(n);    
    
      for (let i = 0; i < unit[0].length && n > 0; i++)     
      {    
          let p = '';    
          for (let j = 0; j < unit[1].length && n > 0; j++)     
          {    
              p = digit[n % 10] + unit[1][j] + p;    
              n = Math.floor(n / 10);    
          }    
          s = p.replace(/(零.)*零$/, '').replace(/^$/, '零')  + unit[0][i] + s;    
      }    
      return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');    
    },
    addMainNum(){
      this.mainContractSignNum++
    },
    delMainNum(i){
      let mainArry = []
      for(let j=0; j<this.mainContractSignNum; j++ ){
        mainArry[j] = this.cForm2['mainContractSignName'+(j+3)]
      }
      this.mainContractSignNum--
      mainArry.splice(i-1, 1)

      for(let m=0; m<this.mainContractSignNum; m++ ){
        this.cForm2['mainContractSignName'+(m+3)] = mainArry[m]
      }
      this.cForm2['mainContractSignName'+(this.mainContractSignNum+3)] = ""
    },
    addSubNum(){
      this.subContractSignNum++
    },
    delSubNum(i){
      let subArry = []
      for(let j=0; j<this.subContractSignNum; j++ ){
        subArry[j] = this.cForm2['subContractSignName'+(j+3)]
      }
      this.subContractSignNum--
      subArry.splice(i-1, 1)

      for(let m=0; m<this.subContractSignNum; m++ ){
        this.cForm2['subContractSignName'+(m+3)] = subArry[m]
      }
      
      this.cForm2['subContractSignName'+(this.subContractSignNum+3)] = ""
    },    
    changeNode(item){
      if(item.isRequire == '0'){
        this.$message.error("此项为必须项，不能删除！");
        this.cForm2.authorityNodeArr.push(item)
      }
    },
    seteNode(obj){
      this.clearData()
      obj.forEach((item, i) => {
        if(item.nodeName == this.cForm2.lawFirmName){
          this.$message.error("律所与权威节点不能选择相同机构！");
          this.cForm2.authorityNodeArr.splice(i, 1)
        }
      })
    },
    setLawFirm(obj){
      // 律所与权威节点不能相同
      let index = this.cForm2.authorityNodeArr.findIndex((item) => item.nodeName === obj.deptName); 
      if(index >= 0){
        this.$message.error("律所与权威节点不能选择相同机构！");
        delete this.cForm2['lawFirmObj']
      }else {
        this.cForm2.lawFirmName = obj.nodeName
        this.cForm2.lawFirm = obj.nodeId
      }      
    },
    getLawFirm(){
      this.$api.api.getDicts("data_saveType").then(response => {
          this.typeOptions = response.data;
      });
      this.queryParams.nodeName = ''
      this.$api.api.nodeList({...this.queryParams,nodeType:'2'}).then(response => {
          if(response.code == 200){
            this.lawOptions = response.rows 
            if(this.cForm2.lawFirmName){
              this.$set(this.cForm2, 'lawFirmObj', {
                nodeName: this.cForm2.lawFirmName,
                nodeId: this.cForm2.lawFirm
              })
            }
          }else {
            this.$message.error(response.msg);
          }      
        });
    },
    uniqueFun(arr,type){
      const res = new Map();
      return arr.filter((a)=>!res.has(a[type])&& res.set(a[type],1));
    },
    getNodeList(){
      this.$api.api.nodeList({...this.queryParams, nodeType: '1'}).then(response => {
        if(response.code == 200){
          this.nodeOptions = response.rows
          this.nodeTotal = response.total
          let authorityArr = []    
          this.nodeOptions.forEach(item => {
            if(item.isRequire == '0'){
              authorityArr.push({
                id: item.id,
                nodeName: item.nodeName
              })
            }
          })  
          if(this.cForm2.authorityNode){            
            let nodeArr = JSON.parse(this.cForm2.authorityNode)
            nodeArr.forEach(item =>{
              if(this.nodeOptions.findIndex((v) => {return v.id == item.id;}) >= 0){
                authorityArr.push({
                  id: item.id,
                  nodeName: item.name
                })
              }             
            })
          }    
          this.$set(this.cForm2, 'authorityNodeArr', this.uniqueFun(authorityArr, 'id')) 
        }else {
          this.$message.error(response.msg);
        }      
      });
    },
    prev() {
      sessionStorage.setpForm = JSON.stringify(this.cForm2);
      this.$emit('prev')
    },
    cSubmitForm(type){
      if(this.cForm2.mainContractPeriod){
        this.cForm2.mainContractPeriodStart = this.cForm2.mainContractPeriod[0]
        this.cForm2.mainContractPeriodEnd = this.cForm2.mainContractPeriod[1]
      }
      if(this.cForm2.subContractPeriod){
        this.cForm2.subContractPeriodStart = this.cForm2.subContractPeriod[0]
        this.cForm2.subContractPeriodEnd = this.cForm2.subContractPeriod[1]
      } 
      if(type == '0'){                  
        this.butLoading = true;
        this.cForm2.status = '0'
        this.cForm2.authorityNode = []
        this.cForm2.authorityNodeArr.forEach(item => {
          this.cForm2.authorityNode.push({
            id: item.id,
            name: item.nodeName
          })
        })
        this.cForm2.authorityNode = JSON.stringify(this.cForm2.authorityNode)
        this.$api.api.saveData(JSON.stringify(this.cForm2)).then(response => {
          this.butLoading = false;
          if(response.code == 200){
            sessionStorage.removeItem("setpForm")
            this.$message.success("保存成功");
            this.$router.push(`/dataContract?sceneType=01`);
          }     
        });
        
      }else{
        this.$refs["cForm2"].validate(valid => {
          if (valid) {
            if(this.nodeTotal >= 4){
              if(this.cForm2.authorityNodeArr.length !== 4){
                this.$message.error("权威节点请选择4个！");
                return false
              }
            }else {
              if(this.cForm2.authorityNodeArr.length !== this.nodeTotal){
                this.$message.error("权威节点请选择"+this.nodeTotal+"个！");
                return false
              }
            }
            this.cForm2.authorityNode = []
            this.cForm2.authorityNodeArr.forEach(item => {
              this.cForm2.authorityNode.push({
                id: item.id,
                name: item.nodeName
              })
            })
            this.cForm2.authorityNode = JSON.stringify(this.cForm2.authorityNode)
            sessionStorage.setpForm = JSON.stringify(this.cForm2);
            this.$emit('next');
          }else {
            this.$nextTick(() => {
              elFormErrorScrollIntoView()
            })
          }
        }) 
      }  
    },
    handleError(err, file, fileList){
      this.$message.error(file.name + "文件上传失败");
    },
    beforeUpload(file) { 	
      const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
      
      if(!isLt2M) {
        this.$message.error('上传文件大小不能超过 80MB！');
      }
      return isLt2M
    },
    cUpload(response, file, list){
        if(response.code == 200){
          this.cForm2.fileName = file.name
          this.cForm2.fileHash = response.data.hash
          this.$set(this.cForm2, 'fileUrl', response.data.path)
        }else{
            this.$message.error(file.name + "文件上传失败");
            this.cForm2.fileName = ''
            this.cForm2.fileHash = ''
            this.cForm2.fileUrl = ''
            this.cFileList = []
        }              
    },
    handleCRemove(file, fileList) {
      this.cForm2.fileName = ''
      this.cForm2.fileHash = ''
      this.cForm2.fileUrl = ''
      this.cFileList = []
    },
  }
}
</script>
